document.addEventListener("DOMContentLoaded", function () {
  let page = 2;
  let loading = false;
  const loadMoreButton = document.getElementById("load-more");
  const loader = document.getElementById("load-spiner");
  if (loadMoreButton) {
    loadMoreButton.addEventListener("click", loadMoreResults);
  }
  async function loadMoreResults() {
    if (loading) return;
    loading = true;
    loadMoreButton.classList.add("button--hidden");
    loader.classList.add("spinner--visible");
    const postType = loadMoreButton.getAttribute("data-post-type");
    const category = loadMoreButton.getAttribute("data-category");
    const year = loadMoreButton.getAttribute("data-year");
    const month = loadMoreButton.getAttribute("data-month");
    let responseJson;

    try {
      const response = await fetch(ajax_object.ajax_url, {
        method: "POST",
        body: new URLSearchParams({
          action: "load_more_ajax",
          page: page,
          post_type: postType,
          category: category,
          year: year,
          month: month,
        }),
      });

      if (response.ok) {
        responseJson = await response.json();
        if (responseJson.success && responseJson.data.content) {
          const container = document.querySelector(".news-archive__list");
          const listItemsLength = container.querySelectorAll(
            ".news-archive__item"
          ).length;
          container.insertAdjacentHTML("beforeend", responseJson.data.content);
          const newItems = container.querySelectorAll(".news-archive__item");
          const firstNewItem = newItems[listItemsLength];
          if (firstNewItem) {
            const firstLink = firstNewItem.querySelector(".news-archive__link");
            if (firstLink) firstLink.focus();
          }
          page++;
        }
      }
    } catch (error) {
      console.error("Fetch error: ", error);
    } finally {
      loading = false;
      loader.classList.remove("spinner--visible");
      if (
        !responseJson ||
        page > responseJson.data.max_num_pages ||
        !responseJson.data.content
      ) {
        loadMoreButton.classList.add("button--hidden");
      } else {
        loadMoreButton.classList.remove("button--hidden");
      }
    }
  }
});
